import React from 'react';
import HtmlGeneratorTab from './coupang/HtmlGeneratorTab';

function CoupangTool() {
  return (
    <div>
      <h1 className="text-2xl font-light text-gray-800 mb-6">쿠팡 상세페이지</h1>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" style={{ height: 'calc(100vh - 160px)' }}>
        <div className="flex h-full">
          <HtmlGeneratorTab />
        </div>
      </div>
    </div>
  );
}

export default CoupangTool;
